<div class="dx-fieldset" style="max-width: 600px;">

  <div class="dx-field">
    <div class="dx-field-label jobListTD">{{ 'URL-Präfix Medienserver' | translate }}</div>
    <div class="dx-field-value">
      <dx-text-box [(value)]="model.urlPrefix" [readOnly]="readOnly" [showClearButton]="!readOnly" (onValueChanged)="update()"></dx-text-box>
    </div>
  </div>

  <div class="dx-field">
    <div class="dx-field-label jobListTD">{{ 'Client Id' | translate }}</div>
    <div class="dx-field-value">
      <dx-text-box [(value)]="model.clientId" [readOnly]="readOnly" [showClearButton]="!readOnly" (onValueChanged)="update()"></dx-text-box>
    </div>
  </div>

  <div class="dx-field">
    <div class="dx-field-label jobListTD">{{ 'Client Secret' | translate }}</div>
    <div class="dx-field-value">
      <dx-text-box mode="password" [(value)]="model.clientSecret" [readOnly]="readOnly" (onValueChanged)="update()"></dx-text-box>
    </div>
  </div>

  <dx-toolbar *ngIf="!readOnly">
    <dxi-item location="before">
      <div *dxTemplate>
        <dx-button text="{{'Verbindung testen' | translate}}" stylingMode="text" type="default" [icon]="isTested ? 'check' : ''" (onClick)="testConnection()"></dx-button>
      </div>
    </dxi-item>
  </dx-toolbar>

  <div style="color: red;">
    {{connectionTestMessage}}
  </div>

</div>
